module.exports = __webpack_public_path__ + "img/total-orders.c0e2a6c3.svg";